import { render, staticRenderFns } from "./CMSBlogList.vue?vue&type=template&id=6ecd0805&"
import script from "./CMSBlogList.vue?vue&type=script&lang=js&"
export * from "./CMSBlogList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports